import React from "react";
import { useNavigate } from "react-router-dom";
import "./Banner.css";

const Banner = () => {
  const navigate = useNavigate();

  return (
    <section className="cta5" aria-labelledby="cta5-heading">
      <div className="cta5-wrap">
        <div className="cta5-main">
          {/* LEFT */}
          <div className="cta5-copy">
            <p className="cta5-kicker">Free strategy session</p>

            <h2 id="cta5-heading" className="cta5-title">
              Get a clear action plan for your <span>website & marketing</span>
            </h2>

            <p className="cta5-sub">
              In one focused session, we review your digital setup, identify what's holding you back, and outline a practical 10-day action plan — at no cost.
            </p>

            <div className="cta5-actions">
              <button
                className="cta5-btn cta5-btnPrimary"
                type="button"
                onClick={() => navigate("/contact")}
              >
                Book your free session
              </button>

              <button
                className="cta5-btn cta5-btnOutline"
                type="button"
                onClick={() => navigate("/services")}
              >
                View our services
              </button>
            </div>
          </div>

          {/* RIGHT */}
          <aside className="cta5-side" aria-label="What you get">
            <p className="cta5-sideLabel">What you'll walk away with</p>
            <p className="cta5-sideSub">A focused review and a practical plan ready to implement straight away.</p>

            <div className="cta5-list">
              <div className="cta5-li">
                <span className="cta5-bullet" />
                <div>
                  <div className="cta5-liTitle">Priority improvements</div>
                  <div className="cta5-liText">The highest-impact fixes, ranked by outcome</div>
                </div>
              </div>

              <div className="cta5-li">
                <span className="cta5-bullet" />
                <div>
                  <div className="cta5-liTitle">Conversion clarity</div>
                  <div className="cta5-liText">Specific page and CTA changes to drive action</div>
                </div>
              </div>

              <div className="cta5-li">
                <span className="cta5-bullet" />
                <div>
                  <div className="cta5-liTitle">Growth checklist</div>
                  <div className="cta5-liText">Know exactly what's working and what to fix next</div>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default Banner;
